import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import { Analytics } from '@vercel/analytics/react'
import App from './App.tsx'
import { CountryProvider } from './context/CountryContext'
import './index.css'

// ============================================
// Analytics & Error Tracking Initialization
// ============================================
import { analytics } from './lib/analytics'
import { initSentry } from './lib/analytics/sentry'

// Initialize Sentry (error tracking)
const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN
if (SENTRY_DSN) {
  initSentry(SENTRY_DSN, import.meta.env.MODE)
}

// Initialize Google Analytics
const GA_MEASUREMENT_ID = import.meta.env.VITE_GA_MEASUREMENT_ID
if (GA_MEASUREMENT_ID) {
  analytics.init(GA_MEASUREMENT_ID, import.meta.env.DEV)
}

// ============================================
// Render App
// ============================================

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <CountryProvider>
          <App />
          <Analytics />
        </CountryProvider>
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>,
)
